import React from "react";
import { connect } from "react-redux";
import { setSiteNotes } from "../../../store/actions";

const defaultState = {
  categoryValue: "",
  selectedCategory: null,
  noteValue: null,
};

class NoteTagCreate extends React.Component {
  static defaultProps = {
    site: {},
    onError: () => console.error("Error in NoteTagCreate component."),
  };

  constructor(props) {
    super(props);

    this.state = {
      ...defaultState,
      displayCategoryOptions: this.props.notes.length === 0,
    };
  }

  handleCategorySearch = (event) => {
    this.setState({ categoryValue: event.target.value });
  };

  onSelectCategory = (category) => {
    this.props.onSelectCategory(category);
    this.setState(
      {
        selectedCategory: category,
        categoryValue: "",
        noteValue: "",
        displayCategoryOptions: false,
      },
      () => {
        if (!category) {
          // this.categoryInput.focus();
        } else {
          this.noteInput.focus();
        }
      }
    );
  };

  renderCategoryOption = (category, onClick, style = {}) => {
    return (
      <div
        className={"category-option"}
        style={{ borderColor: category.color, color: category.color, ...style }}
        onClick={onClick ? onClick : () => this.onSelectCategory(category)}
      >
        {category.name}
      </div>
    );
  };

  handleNoteValueChange = (event) => {
    this.setState({ noteValue: event.target.value });
  };

  displayCategoryOptions = () => {
    return (
      <div className={"category-options"}>
        {this.props.categories.map((d) => this.renderCategoryOption(d))}
      </div>
    );
  };

  render() {
    return (
      <div>
        <div className={"create-note-inputs"}>
          {this.state.selectedCategory ? (
            <div style={{ height: "3.8em" }}>
              {this.renderCategoryOption(
                this.state.selectedCategory,
                () => this.onSelectCategory(null),
                { margin: "0", marginRight: ".5em", fontSize: "1.3em" }
              )}
            </div>
          ) : (
            !this.state.displayCategoryOptions && (
              <button
                className="button button-outline"
                onClick={() => this.setState({ displayCategoryOptions: true })}
              >
                Add Note
              </button>
            )
          )}
          {!!this.state.selectedCategory && (
            <>
              <input
                type={"text"}
                value={this.state.noteValue}
                ref={(x) => (this.noteInput = x)}
                placeholder={"Add a note if you would like"}
                onChange={this.handleNoteValueChange}
                style={{ padding: "0 8px" }}
                // onFocus={() => this.setState({displayCategoryOptions: true})}
                // onBlur={() => this.setState({displayCategoryOptions: false})}
              />
              <button
                // style={{backgroundColor: this.state.selectedCategory.color}}
                className="button"
                onClick={() => {
                  this.props.onCreateNote(
                    this.state.selectedCategory.id,
                    this.state.noteValue
                  );
                  this.setState({
                    ...defaultState,
                    displayCategoryOptions: this.props.notes.length === 0,
                  });
                }}
              >
                Add Note
              </button>
            </>
          )}
        </div>

        {this.state.displayCategoryOptions && this.displayCategoryOptions()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  siteNotes: state.siteNotes.data,
});

const mapDispatchToProps = (dispatch) => ({
  setSiteNotes: (notes) => dispatch(setSiteNotes(notes)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NoteTagCreate);
